import { createSlice } from '@reduxjs/toolkit';
import {
  updateFundManagerDetails,
  getReferencesFundManager,
  getPortfolioFundManager,
} from '../thunk/fundManagerDetailThunk';
import {
  getAssociatedCompanyAssets,
  getCompanyAssetsDetails,
  updateCompanyAssetsDetails,
} from '../thunk/companyAssetsThunk';
const initialState = {
  companyAssetsDetails: null,
  associatedCompanyAssets: [],
  referenceFundManagerData: [],
  portfolioFundManagerData: [],
  loading: false,
  updating: false,
  error: null,
  associatedCompanyAssetsLoading: false,
  referenceFundManagerDataLoading: false,
  portfolioFundManagerDataLoading: false,
};

const companyAssetsDetailSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearCompanyAssetsDetails: (state) => {
      state.companyAssetsDetails = null;
      state.error = null;
      state.associatedFundManagerDetails = [];
      state.referenceFundManagerData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getCompanyAssetsDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyAssetsDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.companyAssetsDetails = action.payload.data;
      })
      .addCase(getCompanyAssetsDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Contact Details
      .addCase(updateCompanyAssetsDetails.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateCompanyAssetsDetails.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      })

      // Associated Investments
      .addCase(getAssociatedCompanyAssets.pending, (state) => {
        state.associatedCompanyAssetsLoading = true;
        state.error = null;
      })
      .addCase(getAssociatedCompanyAssets.fulfilled, (state, action) => {
        state.associatedCompanyAssetsLoading = false;
        state.associatedCompanyAssets = action.payload.data;
      })
      .addCase(getAssociatedCompanyAssets.rejected, (state, action) => {
        state.associatedCompanyAssetsLoading = false;
        state.error = action.payload;
      })

      // Reference Calls
      .addCase(getReferencesFundManager.pending, (state) => {
        state.referenceFundManagerDataLoading = true;
        state.error = null;
      })
      .addCase(getReferencesFundManager.fulfilled, (state, action) => {
        state.referenceFundManagerDataLoading = false;
        state.referenceFundManagerData = action.payload.data;
      })
      .addCase(getReferencesFundManager.rejected, (state, action) => {
        state.referenceFundManagerDataLoading = false;
        state.error = action.payload;
      })

      // get Portfolio Fund Manager
      .addCase(getPortfolioFundManager.pending, (state) => {
        state.portfolioFundManagerDataLoading = true;
        state.error = null;
      })
      .addCase(getPortfolioFundManager.fulfilled, (state, action) => {
        state.portfolioFundManagerDataLoading = false;
        state.portfolioFundManagerData = action.payload.data;
      })
      .addCase(getPortfolioFundManager.rejected, (state, action) => {
        state.portfolioFundManagerDataLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCompanyAssetsDetails } = companyAssetsDetailSlice.actions;
export default companyAssetsDetailSlice.reducer;
